/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { addProductListLinesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductListsDataActions.g';
import { ProductListLine } from '@msdyn365-commerce/retail-proxy';

/**
 * Getaddresses Input Action
 */

export interface IITSaddProductListLinesInput extends Msdyn365.IActionInput {
    id: string;
    productListLines: ProductListLine[];
}
export class GetaddProductListLinesInput implements Msdyn365.IActionInput {
    public id: string;
    public productListLines: ProductListLine[];
    // TODO: Construct the input needed to run the action
    constructor(id: string, productListLines: ProductListLine[]) {
        this.id = id;
        this.productListLines = productListLines;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `addProductListLines`;
    public getCacheObjectType = () => 'addProductListLines';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function addProductListLinesAction(
    request: IITSaddProductListLinesInput,
    ctx: Msdyn365.IActionContext
): Promise<ProductListLine[] | null> {
    if (request.id && request.productListLines) {
        try {
            const result = await addProductListLinesAsync({ callerContext: ctx }, request.id, request.productListLines); //calling getStateCityAsync API
            if (result) {
                return result;
            }
        } catch (error) {
            console.log('Error', error);
        }
    }
    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ProductListLine[] | null>>addProductListLinesAction,
    // TODO: Give your data action a unique id
    id: `addProductListLines`
    // input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
